import { sql } from "drizzle-orm";
import { bigint, integer, json, jsonb, pgEnum, pgTable, text, timestamp, uniqueIndex, uuid, varchar } from "drizzle-orm/pg-core";
import { stepTypeKeyEnum, stepTypes } from "./stepTypes.js";
import { tasks } from "./tasks.js";
export const stepStatus = {
    PENDING: "pending",
    IN_PROGRESS: "in_progress",
    SUCCESS: "success",
    FAILED: "failed",
    TASK_ALREADY_PROCESSED: "task_already_processed",
};
/** The statuses of a step that has not finished yet. */
export const ACTIVE_STEP_STATUSES = [stepStatus.PENDING, stepStatus.IN_PROGRESS];
function enumToPgEnum(myEnum) {
    return Object.values(myEnum);
}
export const stepStatusEnum = pgEnum("step_status", enumToPgEnum(stepStatus));
export const steps = pgTable("step", {
    id: bigint({ mode: "number" }).primaryKey().generatedAlwaysAsIdentity(),
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    type: stepTypeKeyEnum("type")
        .references(() => stepTypes.key)
        .notNull(),
    status: stepStatusEnum("status").notNull(),
    task: bigint("task", { mode: "number" })
        .references(() => tasks.id, { onDelete: "cascade" })
        .notNull(),
    title: varchar("title", { length: 100 }).notNull(),
    input: json("input"), // Data received from previous step, validated against inputSchema
    result: json("result"), // Data produced by this step, validated against resultSchema
    startTime: timestamp("start_time", { withTimezone: true }),
    endTime: timestamp("end_time", { withTimezone: true }),
    failedAttempts: integer("failed_attempts").notNull().default(0),
    nextAttemptAt: timestamp("next_attempt_at", { withTimezone: true }),
    leaseExpiresAt: timestamp("lease_expires_at", { withTimezone: true }),
    claimToken: uuid("claim_token"),
    externalJobId: text("external_job_id"),
    decision: jsonb("decision").$type(),
}, (table) => [
    // One incident_report task per reported Incident: DB-level backstop for the
    // check-then-insert dedup guard in the incident-report creation transaction,
    // and the index behind its per-create lookup.
    uniqueIndex("step_incident_report_incident_claimini_id_uq")
        .on(sql `(${table.input}->>'incidentClaiminiId')`)
        .where(sql `${table.type} = 'incident_report_processing'`),
]);
